import React from 'react'

class Intro extends React.Component {
    render(){
        return(
            <article className="gc">
                <blockquote className="center-text d-4-10 m-span-all">
                    <br />
                    Enter the smorgasbord of wacky and wonderful faces of Lydia Peckham.
                    Ages, backgrounds, interest, desires, insecurities curiosities. 
                    Snippets of moments in woman life.
                    <br />
                </blockquote>
            </article>
        )
    }
}

export default Intro